/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { CATEGORY, SCREEN_NAME } from '../config/analytics';
import {
  SSO_METHOD,
  SSO_VERIFICATION_EMAIL_OTP,
} from './loginSignupAnalyticsUtils';
import { Purpose } from '../managers/sso';

export function resolveEmailOtpAnalytics(purpose: Purpose) {
  const isSignup = purpose === Purpose.EMAIL_OTP_VERIFICATION_SIGNUP;
  const isLogin = purpose === Purpose.EMAIL_OTP_VERIFICATION_LOGIN;
  const is2fa = purpose === Purpose.LOGIN_2FA;

  return {
    enabled: isSignup || isLogin || is2fa,
    isLogin,
    category: isSignup ? CATEGORY.ssoSignup : CATEGORY.ssoLogin,
    screenName: SCREEN_NAME.emailOTPv2,
    method: is2fa ? SSO_METHOD.emailPassword : SSO_METHOD.emailOnly,
    verificationMethod: SSO_VERIFICATION_EMAIL_OTP,
  };
}
